import ten99 from 'Agent/1099s/ducks/1099';

export default {
  ten99,
};
